import { render } from "./ModalVotacionColiseo.vue?vue&type=template&id=34f56317&scoped=true"
import script from "./ModalVotacionColiseo.vue?vue&type=script&lang=js"
export * from "./ModalVotacionColiseo.vue?vue&type=script&lang=js"

import "./ModalVotacionColiseo.vue?vue&type=style&index=0&id=34f56317&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f56317"]])

export default __exports__